module.exports = __webpack_public_path__ + "img/showmorw02.e1a8cfd.png";